import { gql, useQuery } from "@apollo/client";
import getSymbolFromCurrency from 'currency-symbol-map';

const GET_CURRENCY = gql`
query getCurrency {
    organisationSettings(where: {settingName: {_eq: "currency"}}) {
        settingValue
    }
}
`;

/**
 * Hook to fetch and format the organization's currency settings
 * @returns {Object} Currency information
 * @property {string|undefined} currency - The currency code (e.g., 'USD')
 * @property {string|undefined} symbol - The currency symbol (e.g., '$')
 */
export const useCurrency = () => {
  const { data } = useQuery(GET_CURRENCY,
    {
      context: {
        headers: {
          'x-hasura-role': 'learner'
        }
      },
    }
  );

  const currencyCode = data?.organisationSettings[0]?.settingValue;
  const currencySymbol = getSymbolFromCurrency(currencyCode) || currencyCode;

  return { currency: currencyCode, symbol: currencySymbol };
};